<div class="p-3">
  <div class="flex flex-items flex-wrap">
    <div class="card">
      <div class="flex flex-items py-2">
        <div class="circle"
             matTooltip="{{ subAcuteDetails?.averageLOS ?? 0 }}"
             matTooltipPosition="above"
             matTooltipClass="custom-tooltip"
             (mouseenter)="showTooltip(subAcuteDetails?.averageLOS ?? 0)"
             (mouseleave)="hideTooltip()">
          <span class="number">{{ subAcuteDetails?.averageLOS ?? 0 }}</span>
        </div>
        <label class="align-content-center">
          Average LOS for facility
        </label>
      </div>
    </div>
    <div class="card">
      <div class="flex flex-items py-2">
        <div class="circle"
             matTooltip="{{ subAcuteDetails?.averageLOSForLTC ?? 0 }}"
             matTooltipPosition="above"
             matTooltipClass="custom-tooltip"
             (mouseenter)="showTooltip(subAcuteDetails?.averageLOSForLTC ?? 0)"
             (mouseleave)="hideTooltip()">
          <span class="number">{{ subAcuteDetails?.averageLOSForLTC ?? 0 }}</span>
        </div>
        <label class="align-content-center">
          AVG LOS for LTC Therapy Patients
        </label>
      </div>
    </div>
  </div>
  <div class="mt-2">
    <h2>GG Improvement: Total Average</h2>
    <div class="gg-total">2.5</div>
  </div>
  <div class="mt-2">
    <div class="grey-box mb-2">
      Selfcare Average: <span class="ml-2">3.5</span>
    </div>
    <div class="grey-box">
      Mobility Average: <span class="ml-2">3.5</span>
    </div>
  </div>
</div>